import React, { useState } from 'react';
import Modal from './Modal';
import { support } from '../api';
import { FaEnvelope, FaPhoneAlt } from 'react-icons/fa';

function SupportModal({ isOpen, onClose }) {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleClose = () => {
    setSubject('');
    setMessage('');
    setError('');
    setSent(false);
    onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) {
      setError('Please enter a subject and a message.');
      return;
    }
    setSending(true);
    setError('');
    try {
      const res = await support.submit({ subject: subject.trim(), message: message.trim() });
      if (res.success) {
        setSent(true);
      } else {
        setError(res.error || 'Failed to send support request.');
      }
    } catch (err) {
      setError('Failed to send support request. Please email info@onepurposelogistics.com or call 063 598 5855.');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Support">
      {sent ? (
        <div className="text-center py-8">
          <div className="text-4xl mb-4">✅</div>
          <p className="font-semibold text-navy mb-2">Support request sent</p>
          <p className="text-gray-500 text-sm mb-6">
            We've received your message and will get back to you at your registered email address.
          </p>
          <button
            onClick={handleClose}
            className="px-6 py-2 rounded-lg bg-green text-white text-sm font-semibold"
          >
            Close
          </button>
        </div>
      ) : (
        <form onSubmit={submit}>
          <div className="bg-gray-50 rounded-lg p-4 mb-5 flex flex-wrap gap-4 text-sm">
            <div className="flex items-center gap-2 text-gray-600">
              <FaEnvelope className="text-green" />
              <a href="mailto:info@onepurposelogistics.com" className="hover:underline">info@onepurposelogistics.com</a>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <FaPhoneAlt className="text-green" />
              <a href="tel:+27635985855" className="hover:underline">063 598 5855</a>
            </div>
          </div>

          {error && (
            <div className="mb-4 px-4 py-3 rounded-lg bg-red-50 text-red-600 text-sm">{error}</div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="e.g. QBO sync error, can't upload POD..."
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-green"
            />
          </div>

          <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={5}
              placeholder="Describe the issue — we read every message."
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:border-green"
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 rounded-lg border border-gray-200 text-sm hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={sending}
              className="px-6 py-2 rounded-lg bg-green text-white text-sm font-semibold disabled:opacity-50"
            >
              {sending ? 'Sending...' : 'Send to Support'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
}

export default SupportModal;
